export const accessAccountabilityTour = {
    module: 'access_accountability',
    title: 'Access Accountability Tour',
    title_vi: 'Tour Trách nhiệm giải trình truy cập',
    description: 'As the Internal Audit Lead (P-VN-10), review access evidence, audit permission usage, and investigate anomalous patterns to demonstrate GDPR Article 5(1)(f) integrity and confidentiality.',
    description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: As the Internal Audit Lead (P-VN-10), review access evidence, audit permission usage, and investigate anomalous patterns to demonstrate GDPR Article 5(1)(f) integrity and confidentiality.',
    estimated_duration_seconds: 32,
    steps: [
        {
            step_id: 'aa_sessions',
            navigate_to: '/admin/access-accountability/sessions',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Sessions Dashboard',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Sessions Dashboard',
            description: 'As the Internal Audit Lead, you will monitor active sessions here. Device, location, and duration data helps you identify unauthorized access and enforce least-privilege principles.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: As the Internal Audit Lead, you will monitor active sessions here. Device, location, and duration data helps you identify unauthorized access and enforce least-privilege principles.',
            position: 'top',
        },
        {
            step_id: 'aa_session_table',
            target: '.dm-table',
            title: 'Session Details',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Session Details',
            description: 'Each row shows a user session. Click to inspect activity or terminate suspicious sessions immediately -- a key control for preventing unauthorized data access.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Each row shows a user session. Click to inspect activity or terminate suspicious sessions immediately -- a key control for preventing unauthorized data access.',
            position: 'bottom',
        },
        {
            step_id: 'aa_access_log',
            navigate_to: '/admin/access-accountability/access-log',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Access Log',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Access Log',
            description: 'A chronological record of every data access event. Filter by user, resource, or action type to audit who accessed personal data and verify permission appropriateness.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: A chronological record of every data access event. Filter by user, resource, or action type to audit who accessed personal data and verify permission appropriateness.',
            position: 'bottom',
        },
        {
            step_id: 'aa_filters',
            target: '.dm-filters',
            title: 'Filter Access Records',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Filter Access Records',
            description: 'Filter by user, resource type, or status to build targeted permission audit reports for specific teams, systems, or data categories.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Filter by user, resource type, or status to build targeted permission audit reports for specific teams, systems, or data categories.',
            position: 'bottom',
        },
        {
            step_id: 'aa_export',
            target: '.btn-secondary',
            title: 'Export Access Report',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Export Access Report',
            description: 'Export filtered access evidence as a report. These exports serve as audit artifacts demonstrating that access controls are monitored and enforced.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Export filtered access evidence as a report. These exports serve as audit artifacts demonstrating that access controls are monitored and enforced.',
            position: 'top',
        },
        {
            step_id: 'aa_investigations',
            navigate_to: '/admin/access-accountability/investigations',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Access Investigations',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Access Investigations',
            description: 'Open formal investigations into suspicious access patterns. Link evidence from the access log to build a documented case that satisfies regulatory inquiry requirements.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Open formal investigations into suspicious access patterns. Link evidence from the access log to build a documented case that satisfies regulatory inquiry requirements.',
            position: 'bottom',
        },
        {
            step_id: 'aa_justification',
            navigate_to: '/admin/access-accountability/justifications',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Justification Requirements',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Justification Requirements',
            description: 'Configure which data access actions require a documented justification before the system grants access. This enforces purpose limitation under GDPR Article 5(1)(b).',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Configure which data access actions require a documented justification before the system grants access. This enforces purpose limitation under GDPR Article 5(1)(b).',
            position: 'top',
        },
        {
            step_id: 'aa_config',
            navigate_to: '/admin/access-accountability/config',
            wait_for: '.dm-page',
            scroll_to: true,
            target: '.dm-page',
            title: 'Accountability Settings',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Accountability Settings',
            description: 'Adjust session timeout policies, log retention periods, and anomaly alert thresholds. These settings define your baseline access control posture for audit evidence.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Adjust session timeout policies, log retention periods, and anomaly alert thresholds. These settings define your baseline access control posture for audit evidence.',
            position: 'top',
        },
        {
            step_id: 'aa_complete',
            target: '.dm-page',
            title: 'Access Accountability Tour Complete',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Access Accountability Tour Complete',
            description: 'You can now audit permission usage, investigate suspicious access, enforce justification requirements, and export access evidence that demonstrates GDPR Article 5(1)(f) compliance.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: You can now audit permission usage, investigate suspicious access, enforce justification requirements, and export access evidence that demonstrates GDPR Article 5(1)(f) compliance.',
            position: 'bottom',
        },
    ],
};
//# sourceMappingURL=access-accountability.js.map